import { render, staticRenderFns } from "./AppDadosTreinadores.vue?vue&type=template&id=7882f6f9&scoped=true&"
import script from "./AppDadosTreinadores.vue?vue&type=script&lang=js&"
export * from "./AppDadosTreinadores.vue?vue&type=script&lang=js&"
import style0 from "./AppDadosTreinadores.vue?vue&type=style&index=0&id=7882f6f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7882f6f9",
  null
  
)

export default component.exports